import { useEffect, useState } from 'react';

const useWindowResize = (callback) => {
  useEffect(() => {
    // Function to handle resize event
    const handleResize = () => {
      if (callback) {
        callback();
      }
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [callback]);
};

export default useWindowResize;
